import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import s from "./month.js";
import d from "../../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/clickoutside.js";
import { getPreciseEventTarget as h } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/get-precise-event-target.js";
import { defineComponent as m, h as e, withDirectives as p } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as o } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import f from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Binder.js";
import c from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Target.js";
import v from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Follower.js";
import { Transition as g } from "../../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
const x = m({
  props: {
    mergedClsPrefix: {
      type: String,
      required: !0
    },
    value: Number,
    monthBeforeYear: {
      type: Boolean,
      required: !0
    },
    monthYearSeparator: {
      type: String,
      required: !0
    },
    calendarMonth: {
      type: String,
      required: !0
    },
    calendarYear: {
      type: String,
      required: !0
    },
    onUpdateValue: {
      type: Function,
      required: !0
    }
  },
  setup() {
    const a = o(null), t = o(null), r = o(!1);
    function i(u) {
      var n;
      r.value && !(!((n = a.value) === null || n === void 0) && n.contains(h(u))) && (r.value = !1);
    }
    function l() {
      r.value = !r.value;
    }
    return {
      show: r,
      triggerRef: a,
      monthPanelRef: t,
      handleHeaderClick: l,
      handleClickOutside: i
    };
  },
  render() {
    const {
      handleClickOutside: a,
      mergedClsPrefix: t
    } = this;
    return e("div", {
      class: `${t}-date-panel-month__month-year`,
      ref: "triggerRef"
    }, e(f, null, {
      default: () => [e(c, null, {
        default: () => e("div", {
          class: [`${t}-date-panel-month__text`, this.show && `${t}-date-panel-month__text--active`],
          onClick: this.handleHeaderClick
        }, this.monthBeforeYear ? [this.calendarMonth, this.monthYearSeparator, this.calendarYear] : [this.calendarYear, this.monthYearSeparator, this.calendarMonth])
      }), e(v, {
        show: this.show,
        teleportDisabled: !0
      }, {
        default: () => e(g, {
          name: "fade-in-scale-up-transition",
          appear: !0
        }, {
          default: () => this.show ? p(e(s, {
            ref: "monthPanelRef",
            onUpdateValue: this.onUpdateValue,
            actions: [],
            calendarHeaderMonthYearSeparator: this.monthYearSeparator,
            // month and year click show month type
            type: "month",
            key: "month",
            useAsQuickJump: !0,
            value: this.value
          }), [[d, a, void 0, {
            capture: !0
          }]]) : null
        })
      })]
    }));
  }
});
export {
  x as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/panelHeader.js
// module id = 314
// module chunks = 41